import { firestoreAction } from "vuexfire";
import { db, storage } from "@/plugins/firebase";
import firebase from "firebase";
import { FilesState, RootState, User, UserFile } from "@/store/types";
import { ActionTree, GetterTree, Module, MutationTree } from "vuex";

const mutations: MutationTree<FilesState> = {};

const actions: ActionTree<FilesState, RootState> = {
  bindFiles: firestoreAction(async context => {
    // context contains all original properties like commit, state, etc
    // and adds `bindFirestoreRef` and `unbindFirestoreRef`
    // we return the promise returned by `bindFirestoreRef` that will
    // resolve once data is ready
    await context.dispatch("users/waitForUserLoaded", null, { root: true });
    return context.bindFirestoreRef(
      "files",
      db.collection(`${context.rootGetters["users/userRefPath"]()}/files`)
    );
  }),
  unbindFiles: firestoreAction(context => {
    return context.unbindFirestoreRef("files");
  }),
  bindUserAdminFiles: firestoreAction(async (context, userUid) => {
    await context.dispatch("users/waitForUserLoaded", null, { root: true });
    console.log(`${context.rootGetters["users/userRefPath"](userUid)}/files`);
    return context.bindFirestoreRef(
      "userAdminFiles",
      db.collection(
        `${context.rootGetters["users/userRefPath"](userUid)}/files`
      )
    );
  }),
  unbindUserAdminFiles: firestoreAction(context => {
    return context.unbindFirestoreRef("userAdminFiles");
  }),
  addFile: (context, file: UserFile) => {
    // return the promise so we can await the write
    file.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    return db
      .collection(`${context.rootGetters["users/userRefPath"]()}/files`)
      .add(file);
  },
  updateFile: (context, fileProps: any) => {
    // return the promise so we can await the write
    return db
      .collection(`${context.rootGetters["users/userRefPath"]()}/files/`)
      .doc(fileProps.id)
      .set(fileProps, { merge: true });
  },
  deleteFile: async (context, file) => {
    await storage.ref(file.fullPath).delete();
    return db
      .collection(`${context.rootGetters["users/userRefPath"]()}/files/`)
      .doc(file.id)
      .delete();
  }
};

const getters: GetterTree<FilesState, RootState> = {};

const files: Module<FilesState, RootState> = {
  namespaced: true,
  state: {
    files: [],
    userAdminFiles: []
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default files;
